import { Component, computed, inject } from '@angular/core';

import { LayoutService } from 'src/app/core/layout/layout.service';
import { TabListService } from 'src/app/features/shared/central-page/services/tab-list.service';
import { LoadingPageService } from 'src/app/infrastructure/services/loading-services/loading-page.service';
import { FooterService } from '../footer.service';
import { SharedModule } from '../../shared.module';
import { ButtonNavigationComponent } from '../../controls/container/button-navigation/button-navigation.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IconsModule } from '../../icons/icons.module';
import { AppMaterialModule } from '../../material.module';
import { ProgressBarComponent } from '../../progress-bar/container/progress-bar.component';
import { injectRequired } from 'src/app/infrastructure/functions/inject-required.function';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    host: {
        'class': 'footer',
        '(touchstart)': 'emit_touchStart($event)',
        '(touchend)': 'emit_touchEnd($event)',
    },
    standalone: true,
    imports: [
        SharedModule,
        ButtonNavigationComponent,
        ProgressBarComponent,
        AppMaterialModule,
    ],
    styleUrls: ['./footer.component.scss'],
    // animations: [
    //     trigger('swipeDown', [
    //         transition(':enter', [
    //             style({ height: '*' }),
    //             animate(
    //                 '500ms ease-in-out',
    //                 style({ height: '0' })
    //             ),
    //         ]),
    //         transition(':leave', [
    //             style({ height: '0' }),
    //             animate(
    //                 '500ms ease-in-out',
    //                 style({ height: '*' })
    //             ),
    //         ]),
    //     ]),
    // ]
})
export class FooterComponent {
    private __footerService = injectRequired(FooterService);
    private __layoutService = injectRequired(LayoutService);
    private __loadingPageService = injectRequired(LoadingPageService);
    private __tabListService = inject(TabListService, {optional: true});

    private __footerData$$ = this.__footerService.footerData$$;

    // Content-container (de tab-gebonden knoppen) mag pas verschijnen zodra de bijbehorende
    // pagina-/tab-inhoud ook echt getoond wordt — anders staan de knoppen er al terwijl de
    // content-container zelf nog leeg/hidden is. De side-containers (terug-/menuknop) horen bij
    // het vaste frame en blijven altijd meteen zichtbaar.
    loadingPage$$ = this.__loadingPageService.isLoading$$;

    hideSideBlockLeft$$ = computed(() => this.__footerData$$()?.hideSideBlockLeft);
    hideSideBlockRight$$ = computed(() => this.__footerData$$()?.hideSideBlockRight);
    hideActionButtons$$ = computed(() => this.__footerData$$()?.hideActionButtons);
    showInfoBlock$$ = computed(() => this.__footerData$$()?.showInfoBlock);
    info$$ = computed(() => this.__footerData$$()?.info);
    infoTooltip$$ = computed(() => this.__footerData$$()?.infoTooltip);

    template_contentBlock$$ = this.__footerService.template_contentBlock$$;
    template_buttonLeft$$ = this.__footerService.template_buttonLeft$$;
    template_buttonRight$$ = this.__footerService.template_buttonRight$$;

    // @Input() footerData: IFooterData;
    // @Input() public toCachePage: IPageRouteData;
    // @Output() public btnCacheClick = new EventEmitter();

    emit_touchStart(e: TouchEvent): void {
        this.__tabListService?.footer_swipe(e, 'start');
    }

    emit_touchEnd(e: TouchEvent): void {
        this.__tabListService?.footer_swipe(e, 'end');
    }

    toggleSidenav() {
        this.__layoutService.toggleSideNav();
    }

    // toCacheClick() {
    //     this.btnCacheClick.emit();
    // }
}
